import type { Options } from 'ky'
import { httpClient } from '@/utils/http'

export const asyncsService = {
  amendCalculation: (id: string, options?: Options) =>
    httpClient
      .post('asyncs/calculate_amend_fee', {
        ...options,
        json: {
          id,
        },
      })
      .json(),
}
